import { GridLegacy as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";
import {
  EditableField,
  EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import { IDropDownListItem } from "../../components/editable/EditableField/fields/DropDownField";
import {
  EditableGroup,
  EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import {
  BookingsPageVersion,
  IPreferences,
} from "../../logic/api";
import styles from "./styles";
import {
  ReleaseFlag,
  useReleaseManagement,
} from "../../utility/feature-management";

interface BookingsPageSettingsProps {
  preferences: IPreferences;
  onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const BookingsPageSettings = ({
  preferences,
  onSave,
}: BookingsPageSettingsProps) => {
  const { t } = useTranslation();
  const isBookingsPageV2Released = useReleaseManagement(ReleaseFlag.releaseBookingsPageV2);

  if (!isBookingsPageV2Released) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <NotchedCard
        label={t("settings.bookingsPage")}
        style={styles.card}
        containerProps={{ "data-testid": "bookings-page-settings-card" }}
      >
        <EditableGroup<IPreferences>
          id="bookingsPageSettings"
          testId="settings-bookings-page-group"
          editType={EditableGroupType.switchableEditing}
          data={preferences}
          onDataChanged={(data) =>
            onSave({
              bookings_page_version: data.bookings_page_version,
            })
          }
        >
          <Grid container>
            <EditableField<IPreferences, IDropDownListItem>
              testId="settings-bookings-page-version-field"
              inputType={EditableFieldTypes.enumDropDownField}
              label={t("settings.version")}
              onProvide={(data) => ({
                name: "",
                value: String(data.bookings_page_version ?? BookingsPageVersion.V1),
              })}
              onRequestText={(data) =>
                data.bookings_page_version === BookingsPageVersion.V2
                  ? t("settings.bookingsPageVersion2")
                  : t("settings.bookingsPageVersion1")
              }
              onChange={(data, value) => {
                data.bookings_page_version = Number(value.value) as BookingsPageVersion;
              }}
              onRequestData={async () => [
                {
                  name: t("settings.bookingsPageVersion1"),
                  value: BookingsPageVersion.V1.toString(),
                },
                {
                  name: t("settings.bookingsPageVersion2"),
                  value: BookingsPageVersion.V2.toString(),
                },
              ]}
            />
          </Grid>
        </EditableGroup>
      </NotchedCard>
    </Grid>
  );
};
